document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.tc-reveal, .tc-reveal-stagger');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('tc-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-tc-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-tc-galeria-principal]');
    var miniaturas = galeria.querySelectorAll('[data-tc-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        miniaturas.forEach(function (m) { m.classList.remove('is-activa'); });
        mini.classList.add('is-activa');
      });
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-tc-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-tc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-tc-precio]');
    var precioTachadoEl = form.querySelector('[data-tc-precio-tachado]');
    var botonComprar = form.querySelector('[data-tc-boton-comprar]');
    var stockEl = form.querySelector('[data-tc-stock]');
    var selectores = form.querySelectorAll('[data-tc-opcion]');

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selectores, function (grupo) {
        var activo = grupo.querySelector('.is-seleccionado');
        return activo ? activo.getAttribute('data-valor') : null;
      });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = moneda(variante.compare_at_price);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
      if (stockEl) {
        stockEl.textContent = variante.available
          ? stockEl.getAttribute('data-texto-disponible')
          : stockEl.getAttribute('data-texto-agotado');
        stockEl.classList.toggle('disponible', variante.available);
        stockEl.classList.toggle('agotado', !variante.available);
      }
    }

    selectores.forEach(function (grupo) {
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-seleccionado'); });
          btn.classList.add('is-seleccionado');
          actualizar();
        });
      });
    });

    actualizar();
  });
}
